import { type CSSProperties, type ReactNode, useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

export function ButtonsRow(props: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  const equalizer = useRef<HTMLDivElement | null>(null);

  useEffect(
    function () {
      if (equalizer?.current == null) {
        return;
      }
      const buttons = equalizer.current.querySelectorAll('button');
      if (buttons.length <= 1) {
        return;
      }
      let maxHeight = 0;
      for (let i = 0; i < buttons.length; i++) {
        const { height } = buttons[i].getBoundingClientRect();
        maxHeight = Math.max(maxHeight, height);
      }
      if (maxHeight === 0) {
        return;
      }
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].style.height = `${maxHeight}px`;
      }
    },
    [equalizer]
  );

  return (
    <div
      className={twMerge('flex items-center justify-between gap-3', props.className ?? '')}
      ref={equalizer}
      style={props.style}
    >
      {props.children}
    </div>
  );
}
